module.exports = __webpack_public_path__ + "media/images/logo-7bbfb91037256fce26c976a84ef9498a.svg";